import { createContext, useContext, useState, ReactNode } from 'react'
import { CountryBlockingState, CountryBlockingContextType } from '@/types'

const CountryBlockingContext = createContext<CountryBlockingContextType | undefined>(undefined)

export function useCountryBlocking() {
  const context = useContext(CountryBlockingContext)
  if (context === undefined) {
    throw new Error('useCountryBlocking must be used within a CountryBlockingProvider')
  }
  return context
}

interface CountryBlockingProviderProps {
  children: ReactNode
}

export function CountryBlockingProvider({ children }: CountryBlockingProviderProps) {
  const [countryBlocking, setCountryBlockingState] = useState<CountryBlockingState>({
    isBlocked: false,
    message: undefined,
    userCountry: undefined,
    blockedAt: undefined
  })

  const setCountryBlocking = (state: CountryBlockingState) => {
    setCountryBlockingState({
      ...state,
      blockedAt: state.isBlocked ? new Date() : undefined
    })
  }

  const clearCountryBlocking = () => {
    setCountryBlockingState({
      isBlocked: false,
      message: undefined,
      userCountry: undefined,
      blockedAt: undefined
    })
  }

  return (
    <CountryBlockingContext.Provider 
      value={{
        countryBlocking,
        setCountryBlocking,
        clearCountryBlocking
      }}
    >
      {children}
    </CountryBlockingContext.Provider>
  )
}